import { Box, Button, Card, Image, Layer } from 'grommet';

export type EnlargedFrameModalProps = {
  enlargedFrameUrl?: string;
  setEnlargedFrameUrl: (val: string) => void;
};

export const EnlargedFrameModal = ({ enlargedFrameUrl, setEnlargedFrameUrl }: EnlargedFrameModalProps) => {
  /** Render **/
  return (
    <Layer
      onEsc={() => setEnlargedFrameUrl('')}
      onClickOutside={() => setEnlargedFrameUrl('')}
      position="center"
      modal={true}
    >
      <Card pad="small" style={{ maxHeight: '90vh', maxWidth: '90vw' }}>
        <Box width="xlarge" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          <Image src={enlargedFrameUrl} fit="contain" style={{ maxHeight: 'calc(90vh - 80px)' }} />
        </Box>
        <Box direction="row" justify="end" margin={{ top: 'small' }}>
          <Button label="Close" onClick={() => setEnlargedFrameUrl('')} size="small" />
        </Box>
      </Card>
    </Layer>
  );
};
